// import CONSTANTS from '@picsio/db/src/constants';
import {
  /* WebIcon, TrashIcon, */ Idea, CopyToClipboard, Download,
} from '@picsio/icons';

export default [
  // {
  //   id: 'locale',
  //   text: 'Transcribing language',
  //   Icon: WebIcon,
  //   items: Object.keys(CONSTANTS.assets.transcribe.availableLanguages).map((id) => ({
  //     id,
  //     text: CONSTANTS.assets.transcribe.availableLanguages[id],
  //   })),
  // },
  // {
  //   id: 'menuDelete',
  //   text: 'Delete transcript',
  //   Icon: TrashIcon,
  // },
  {
    id: 'menuCopySettings',
    text: 'Copying transcript settings',
    Icon: CopyToClipboard,
  },
];

export const download = {
  id: 'menuDownload',
  text: 'Download SRT',
  Icon: Download,
};

export const suggestImprovement = {
  id: 'menuSuggestImprovement',
  text: 'Suggest improvement',
  Icon: Idea,
};
